import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@core';
import { AiEntitlementEntity } from '../../domain/entities/ai-entitlement.entity';

/**
 * AI Entitlement REST API service.
 * Handles HTTP communication with the Core BC AI entitlement endpoint.
 */
@Injectable({
  providedIn: 'root',
})
export class AiEntitlementRestApi {
  private readonly _http = inject(HttpClient);
  private readonly _config = inject(AppConfigService);
  private readonly _baseUrl = `${this._config.versionedApiUrl}/ai-entitlement`;

  /**
   * Gets the AI entitlement configuration for the current tenant.
   * @returns Observable with AI entitlement data
   */
  public getAiEntitlement(): Observable<AiEntitlementEntity> {
    return this._http.get<AiEntitlementEntity>(this._baseUrl);
  }

  /**
   * Updates the AI entitlement configuration for the current tenant.
   * @param data - The AI entitlement data to update
   * @returns Observable that completes on success
   */
  public updateAiEntitlement(data: AiEntitlementEntity): Observable<void> {
    return this._http.put<void>(this._baseUrl, data);
  }
}
